import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { StuffList } from '../../stuff';
import TooltipDialog from '../dialog/TooltipDialog';

// 물품 및 수량(모바일) — 데스크톱과 같은 물품 라이브러리, 도움말은 다이얼로그로 연다.
const MAX_BY_NAME = { documentCnt: 100, smallBoxCnt: 50, heavyBoxCnt: 40, greateBoxCnt: 24 };

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingTop: 50,
  },
  title: {
    paddingBottom: 20,
  },
}));

function GoodsAndCountM({ goodsItem, qsStore }) {
  const cs = useStyles();
  const [helpItem, setHelpItem] = useState(null);
  const { handleOptions, orderCalAPI, options } = qsStore;

  const handleChange = async (name, value) => {
    await handleOptions(name, value);
    if (name !== 'etcDesc') await orderCalAPI();
  };

  const items = goodsItem.map((it) => ({ ...it, max: it.max || MAX_BY_NAME[it.name] || 100 }));
  // 스토어 옵션을 펼쳐 넘긴다 — observer 가 각 수량 키를 추적해 스테퍼 값이 바로 바뀐다
  const values = { ...options };

  return (
    <div className={cs.root}>
      <TooltipDialog open={Boolean(helpItem)} item={helpItem} handleClose={() => setHelpItem(null)} />
      <Grid className={cs.title} container direction="column" justify="center" alignItems="center">
        <Typography variant="body1" color="primary">
          <b>물품 및 수량</b>
        </Typography>
        <Typography variant="caption" color="textPrimary" align="center">
          <span className="pColor"><b>TIP.</b></span>
          물음표를 누르시면, 크기와 무게기준을 알려드려요.
        </Typography>
      </Grid>
      <StuffList
        dense
        items={items}
        values={values}
        onChange={handleChange}
        onHelp={setHelpItem}
      />
    </div>
  );
}

export default inject('qsStore')(observer(GoodsAndCountM));
